import { Fragment } from 'react';

import useClubGroupListAdd from './UseClubGroupListAdd';

import ClubGroupsLoadingModal from '../../components/dialogs/loadingModal/ClubGroupsLoadingModal';

import Headings from '@usas/ui-web/components/headings/Headings';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import GroupInfoForm from '@usas/ui-web/components/forms/groups/GroupInfoForm';

import { LOADING_MSG, SAVING_MSG } from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const ClubGroupListAdd = () => {
  const {
    isSaving,
    isLoading,
    state,
    formState,
    errorState,
    handleSubmit,
    onFormValueChanged,
    onBackClicked,
    orgUnitId
  } = useClubGroupListAdd();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Add List Group</Headings.H3>
        </div>
      </div>
      <form onSubmit={handleSubmit} noValidate>
        <GroupInfoForm
          formState={formState}
          errorState={errorState}
          orgUnitId={orgUnitId}
          onFormValueChanged={onFormValueChanged} />
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
            <PrimaryButton type="submit">Create Group</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onBackClicked}>Back</SecondaryButton>
            {errorState && errorState.errorOnSubmitAction
              && <p className={global.ErrorMessage}>{errorState.errorOnSubmitAction}</p>
            }
          </div>
        </div>
      </form>
      <ClubGroupsLoadingModal
        isLoading={isLoading || isSaving}
        loadingMessage={isSaving ? SAVING_MSG : LOADING_MSG}
        isError={state.pageErrorMessage !== ''}
        errorMessage={state.pageErrorMessage} />
    </Fragment>
  );
};

export default ClubGroupListAdd;